<template>
  <v-radio-group
    v-bind="this.$attrs"
    @change="$emit('change', type)"
    v-model="type"
    row
    class="shrink mt-0 pt-0 d-flex align-center"
    style="height: 100%"
    hide-details
  >
    <div style="width: 100%" class="d-flex align-center">
      <v-radio hide-details value="all">
        <div slot="label" class="text-body-2">Tất cả</div>
      </v-radio>
      <v-radio hide-details value="validAbsent">
        <div slot="label" class="text-body-2">{{ $vuetify.breakpoint.mdAndDown ? 'CP' : 'Có phép' }}</div>
      </v-radio>
      <v-radio hide-details value="invalidAbsent">
        <div slot="label" class="text-body-2">{{ $vuetify.breakpoint.mdAndDown ? 'KP' : 'Không phép' }}</div>
      </v-radio>
      <v-radio hide-details value="absent">
        <div slot="label" class="text-body-2">{{ $vuetify.breakpoint.mdAndDown ? 'Chưa XL' : 'Chưa xử lý' }}</div>
      </v-radio>
    </div>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    type: '',
  }),
  props: {},
  created() {},
  watch: {},
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
